<template>
  <v-dialog v-model="dialog" persistent max-width="800px" :attach="attach">
    <component
      v-bind:is="currentComponent"
      @close="dialog = false"
      :item="item"
      :page="page"
    ></component>
  </v-dialog>
</template>

<script>
import ContextSettings from '@/views/Context/components/ContextSettings';
import ContextPermissions from '@/views/Context/components/ContextSettings/ContextPermissions';
import WorkspaceSettings from '@/components/Explorer/WorkspaceSettings';
import { mapState, mapMutations } from 'vuex';
export default {
  data() {
    return {};
  },
  components: { ContextSettings, WorkspaceSettings, ContextPermissions },
  computed: {
    ...mapState('components/settingsModal', ['show', 'item', 'type', 'page', 'attach']),
    dialog: {
      get() {
        return this.show;
      },
      set(v) {
        if (v == false) {
          this.clearModal();
        }
      }
    },
    componentMap() {
      return {
        context: ContextSettings,
        contextPermissions: ContextPermissions,
        workspace: WorkspaceSettings
      };
    },
    currentComponent() {
      return this.componentMap[this.type];
    }
  },
  methods: {
    ...mapMutations('components/settingsModal', ['setModal', 'clearModal'])
  }
};
</script>

<style></style>
